<template>
  <div v-if="AllArticulos" class="miSeleccion">
    <h4 @click="toggleCollapse()">
      <span :class="'box uc '+tipo">{{ tipo.substring(0,1) }}</span>
      <span class="text">{{ tipo }} ( {{ ArticulosMarcados }}/{{ AllArticulos }} )</span>
      <span class="icon"><i :class=" (notCollapsed) ? 'fa fa-angle-up': 'fa fa-angle-down' "></i></span>
    </h4>
    <table class="table table-hover" v-show="notCollapsed"> 
      <thead> 
        <tr> 
          <th width=" 5%"></th>
          <th width=" 4%" class="center">#</th> 
          <th width=" 4%" @click="sortBy('seleccionado')" class="center"># <i class="fa fa-sort"></i></th> 
          <th width="30%" @click="sortBy('titulo')">{{ $t('Título') }} <i class="fa fa-sort"></i></th> 
          <th width="20%" @click="sortBy('autor')">{{ $t('Autor') }} <i class="fa fa-sort"></i></th> 
          <th width=" 9%" @click="sortBy('formato')">{{ $t('Formato') }} <i class="fa fa-sort"></i></th> 
          <th width=" 7%" @click="sortBy('precio')" class="align-right">{{ $t('Precio') }} <i class="fa fa-sort"></i></th> 
          <th width=" 9%" class="align-right">{{ $t('Cantidad') }}</th> 
          <th width=" 8%" @click="sortBy('importe')" class="align-right">{{ $t('Importe') }} </th> 
          <th width=" 4%"></th>
        </tr> 
      </thead> 
      <tfoot>
        <tr class="selected-data">
          <td></td>
          <td></td>
          <td class="center">{{ ArticulosMarcados }}</td>
          <td colspan="4">{{ $t('Artículos marcados') }}</td>
          <td class="align-right">{{ CantidadArticulosMarcados }}</td>
          <td class="align-right">{{ toCurrency(ImporteTotalMarcados) }}</td>
          <td></td>
        </tr>
        <tr class="unselected-data">
          <td></td>
          <td></td>
          <td class="center">{{ AllArticulos - ArticulosMarcados }} </td>
          <td colspan="4">{{ $t('Artículos no marcados') }}</td>
          <td class="align-right">{{ CantidadArticulosNoMarcados }}</td>
          <td class="align-right">{{ toCurrency(ImporteTotalNoMarcados) }}</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="4">
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="checkAllType()">{{ $t('Marcar todos') }}</a>
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="uncheckAllType()">{{ $t('Desmarcar todos') }}</a>
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="deleteAllType()">{{ $t('Vaciar lista') }}</a>
          </td>
          <td colspan="2" class="align-right buy-type">
            <router-link 
              :to="{ name: 'pedido', params: { language: getLocale, tipo: tipo } }" 
              :class="'buy-link '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )">
                {{ $t('Comprar') + ' ' + tipo }}
            </router-link>
          </td>
          <td></td>
        </tr>
      </tfoot>
      <tbody> 
        <tr v-for=" (item, index) in filteredData " :class=" (item.descatalogado || item.proximamente)  ? 'descatalogado' : '' " :key="index"> <!--  -->
          <td class="padding0"><span :class="'box uc '+tipo">{{ tipo.substring(0,1) }}</span></td>
          <th scope="row" class="center">{{ index + 1 }}</th> 
          <td class="center">
            <div v-if=" item.seleccionado == null || deleteLoading[index] == true"><img src="@/assets/img/loading-mini.gif" ></div>
            <a v-else @click.prevent="toogleChecked(item.id_articulo, item.seleccionado, item.cantidad)" href="#" :class="tipo+'-ckeckbox'">
              <i v-if="item.seleccionado" class="fa fa-check-square-o"></i>
              <i v-else class="fa fa-square-o"></i>
            </a>
          </td> 
          <td class="title modal-link" v-on:click.prevent="showModalFichaExtendida(item.id_articulo, item.tipo)"><!-- <a href="#" v-on:click.prevent="showModalFichaExtendida(item.id_articulo, item.tipo)" class="modal-link"> -->{{ item.titulo }}<!-- </a> --></td>
          <td>{{ item.autor }}</td> 
          <td class="uc">{{ item.formato }}</td> 
          <td class="align-right">{{ toCurrency(item.precio) }}</td>
          <td class="align-right">
            <template v-if=" item.descatalogado ">
              <i class="fa fa-ban"></i>
            </template>
            <template v-else-if=" item.proximamente ">
              {{ item.proximamente }}
            </template>
            <template v-else>
              <!-- <i class="fa fa-exclamation-triangle mr5 mhover red" title="Preventa: disponible a partir del 10/10/2021"></i> -->
              <input type="number" min="1" max="9999"
                v-if="deleteLoading[index] != true"
                :value="item.cantidad"     
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-on:input="updateQuantity(item.id_articulo, $event.target.value)">
            </template>
          </td>
          <td class="align-right">
            <div v-if=" item.importe == null "><img src="@/assets/img/loading-mini.gif" ></div>
            <template v-else>{{ toCurrency(item.importe) }}</template>
          </td>
          <td class="center">
            <a v-if=" deleteLoading[index] != true " @click.prevent="deleteArticulo(item.id_articulo, index)" href="#">
              <i class="fa fa-times-circle"></i>
            </a>
            <div v-else><img src="@/assets/img/loading-mini.gif" ></div>
          </td>
        </tr> 
      </tbody> 
    </table>
  </div>
</template>

<i18n>
  {
    "es": {
      "Título": "Título",
      "Autor": "Autor",
      "Formato": "Formato",
      "Precio": "Precio",
      "Cantidad": "Cantidad",
      "Importe": "Importe",
      "Comprar": "Comprar",
      "Marcar todos": "Marcar todos",
      "Desmarcar todos": "Desmarcar todos",
      "Vaciar lista": "Vaciar lista",
      "Artículos marcados": "Artículos marcados",
      "Artículos no marcados": "Artículos no marcados"
    },
    "en": {
    },
    "ca": {
      "Título": "Títol",
      "Autor": "Autor",
      "Formato": "Format",
      "Precio": "Preu",
      "Cantidad": "Quantitat",
      "Importe": "Import",
      "Comprar": "Comprar",
      "Marcar todos": "Marcar tots",
      "Desmarcar todos": "Desmarcar tots",
      "Vaciar lista": "Buidar llista",
      "Artículos marcados": "Articles marcats",
      "Artículos no marcados": "Articles no marcats"
    }
  }
</i18n>

<script>
  import { mapGetters, mapMutation } from 'vuex';

	export default {
    props: ['tipo', 'datos', 'show', 'productID', 'type'],
    data: () => {
      return {
        deleteLoading: [],
        sortKey: '',
        sortOrders: { seleccionado: 1, titulo: 1, autor: 1, formato: 1, precio: 1, importe: 1 },
        filteredData: [],
        notCollapsed: false,
      }
    },
    created(){ },
    mounted(){ },
    computed: { 
      ...mapGetters(['getMiSeleccion', 'getLocale']),
      MiSeleccion: function(){
        this.filteredData = this.$store.getters.getMiSeleccion(this.tipo);
        return this.$store.getters.getMiSeleccion(this.tipo);
      },
      ArticulosMarcados: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.filter( (item) => item.seleccionado == 1).length;
        }else{ return 0 }
      },
      AllArticulos: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.length;
        }else{ return 0 }
      },
      CantidadArticulosMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 1)).reduce(
            (total, articulo) => total + parseInt(articulo.cantidad), 0);
        }else{ return 0 }
      },
      CantidadArticulosNoMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 0)).reduce(
            (total, articulo) => total + parseInt(articulo.cantidad), 0);
        }else{ return 0 }
      },
      ImporteTotalMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 1)).reduce(
            (total, articulo) => total + (articulo.precio * articulo.cantidad), 0).toFixed(2);
        }else{ return 0 }
      },
      ImporteTotalNoMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 0)).reduce(
            (total, articulo) => total + (articulo.precio * articulo.cantidad), 0).toFixed(2);
        }else{ return 0 }
      },
      MiSeleccionLength: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.length;
        }else{ return 0 }
      },
      /*filteredData: function () {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.MiSeleccion
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      }*/
    },
    methods:{
      filterData() {
        var sortKey = this.sortKey
        var order = this.sortOrders[sortKey] || 1
        var data = this.MiSeleccion
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        this.filteredData = data;
      },
      toogleChecked(id_articulo){
        this.$store.dispatch('updateChecked', { id_articulo: id_articulo, tipo: this.tipo } );     
      },
      deleteArticulo(id_articulo, index){
        if( confirm('¿Estás seguro de borrar el artículo?') ){
          this.deleteLoading.splice(index, 1, true);
          this.$store.dispatch('deleteArticulo', { id_articulo: id_articulo, tipo: this.tipo } );     
        }
      },
      updateQuantity(id_articulo, value){
        this.$store.dispatch('updateCantidad', { id_articulo: id_articulo, tipo: this.tipo, cantidad: value } );      
      },
      sortBy(key){
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        this.filterData();
      },
      checkAllType(){
        this.$store.dispatch('checkAllArticulosTipo', { tipo: this.tipo } );  
      },
      uncheckAllType(){
        this.$store.dispatch('uncheckAllArticulosTipo', { tipo: this.tipo } );  
      },
      deleteAllType(){
        if( confirm('¿Estás seguro de borrar todos los artículos?') ){
          for(let i=0; i<this.deleteLoading.length; i++){
            this.deleteLoading.splice(i, 1, true);
          }
          this.$store.dispatch('deleteAllArticulosTipo', { tipo: this.tipo } );  
        }
      },
      toggleCollapse(){ this.notCollapsed = !this.notCollapsed; },
      showModalFichaExtendida(id, tipo){
        this.$emit('update:show', true);
        this.$emit('update:productID', id);
        this.$emit('update:type', tipo.substr(0,1).toUpperCase() );
      }
    },
    watch:{
      MiSeleccion: function() { 
        this.deleteLoading = [];
        for(var i = 0; i<this.MiSeleccion.length; i++){
          this.deleteLoading.splice(i, 1, false);
        }
      }
    }
  }
</script>
